import { LanguageCode } from 'components/LanguageSelector';
import { KnowledgeArticleLanguageCode } from 'models/globalTypes';
import { subscribe } from 'utils/eventManager';
import {
  initGlobalState,
  setGlobalState,
} from 'utils/globalState';
import i18n from 'i18n';

  /** Language for the knowledge articles search */
export const useKnowledgeArticlesLanguage = initGlobalState(
  'knowledgeArticlesLanguage',
  KnowledgeArticleLanguageCode.en,
);

/** Language for the UI content */
export const useContentLanguage = initGlobalState<LanguageCode>(
  'contentLanguage',
  localStorage.getItem('LANGUAGE') as LanguageCode || 'en',
);

subscribe('contentLanguage', contentLanguage => {
  if (contentLanguage === null) {
    setGlobalState('contentLanguage', 'en');
    return;
  }
  i18n.changeLanguage(contentLanguage);

  let knowledgeArticlesLanguage = contentLanguage;
  if (contentLanguage === 'pt') knowledgeArticlesLanguage = 'pt_BR';
  if (contentLanguage === 'zh-Hans') knowledgeArticlesLanguage = 'zh';
  setGlobalState('knowledgeArticlesLanguage', knowledgeArticlesLanguage);
});
